import React from "react";
import "../css/Skeleton.css";

export const SkeletonCard = () => (
  <div className="sk-card">
    <div className="sk-image sk-shimmer" />
    <div className="sk-line sk-shimmer" style={{ width: "75%", height: "15px" }} />
    <div className="sk-line sk-line-price sk-shimmer" style={{ width: "45%", height: "16px" }} />
  </div>
);

export const SkeletonRow = () => (
  <div className="sk-row">
    <div className="sk-row-image sk-shimmer" />
    <div className="sk-row-lines">
      <div className="sk-line sk-shimmer" style={{ width: "65%", height: "16px" }} />
      <div className="sk-line sk-shimmer" style={{ width: "35%", height: "13px" }} />
      <div className="sk-line sk-shimmer" style={{ width: "25%", height: "15px" }} />
    </div>
  </div>
);

export const SkeletonDetail = () => (
  <div className="sk-detail">
    <div className="sk-detail-image-wrap">
      <div className="sk-detail-thumbs">
        <div className="sk-detail-thumb sk-shimmer" />
        <div className="sk-detail-thumb sk-shimmer" />
        <div className="sk-detail-thumb sk-shimmer" />
      </div>
      <div className="sk-detail-image sk-shimmer" />
    </div>
    <div className="sk-detail-info">
      <div className="sk-line sk-shimmer" style={{ width: "30%", height: "14px" }} />
      <div className="sk-line sk-shimmer" style={{ width: "85%", height: "28px" }} />
      <div className="sk-line sk-shimmer" style={{ width: "40%", height: "24px" }} />
      <div className="sk-line sk-shimmer" style={{ width: "100%", height: "1px", margin: "8px 0" }} />
      <div className="sk-line sk-shimmer" style={{ width: "35%", height: "14px" }} />
      <div className="sk-detail-pills-row">
        <div className="sk-detail-pill sk-shimmer" />
        <div className="sk-detail-pill sk-shimmer" />
        <div className="sk-detail-pill sk-shimmer" />
        <div className="sk-detail-pill sk-shimmer" />
      </div>
      <div className="sk-detail-btn-row">
        <div className="sk-detail-btn sk-shimmer" />
        <div className="sk-detail-btn sk-shimmer" />
      </div>
      <div className="sk-line sk-shimmer" style={{ width: "95%", height: "16px", marginTop: "14px" }} />
      <div className="sk-line sk-shimmer" style={{ width: "80%", height: "16px" }} />
    </div>
  </div>
);
